import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { VisualizzaStatoFatturePRComponent } from './visualizza-stato-fatture-pr';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.visualizza-stato-fatture-pr', {
            url: '/visualizza-stato-fatture-pr',
            params: {
                'numeroFattura': ''
            },
            ncyBreadcrumb: {
                label: 'Fatture Trasmesse',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Fatture Trasmesse'
            },
            'views': {
                'homeContent': {
                    template: '<visualizza-stato-fatture-pr flex="100"></visualizza-stato-fatture-pr>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const VisualizzaStatoFatturePRModule: string = ng
    .module('visualizza-stato-fatture-pr', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('visualizzaStatoFatturePr', VisualizzaStatoFatturePRComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/visualizza-stato-fatture-pr/visualizza-stato-fatture-pr.module.ts